import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearClientsAction, clearSelectedClientAction, getClientsActions } from '../../redux/actions/clientsActions';

const useFetchClients = ({ unpaged = false }) => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.clients?.search);
  const clients = useSelector((state) => state.clients?.clients);
  const loading = useSelector((state) => state.clients?.loading);

  const fetchClients = useCallback(async () => {
    await dispatch(getClientsActions(search, unpaged));
  }, [search, unpaged, dispatch]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  useEffect(() => {
    return () => {
      dispatch(clearClientsAction());
      dispatch(clearSelectedClientAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchClients();
  };

  return { loading, clients, refresh };
};

export default useFetchClients;
